import WithSidebar from 'Layout/WithSidebar';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import { filesUniferX, filesWuxal } from './mockData';
import PDFBox from 'components/PDFBox';
import wuxalCatalog from 'images/wuxalCatalog.jpg';
import uniferCatalog from 'images/unifer-catalog.jpg';
import ProductCatalogBox from 'components/ProductCatalogBox';
import { informationMaterials } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInformationMaterials, selectInformationMaterialsPage } from 'store/slices/InformationMaterialsSlice';
import { useEffect } from 'react';
// {
//     "preview_title": "Information materials",
//     "preview_image": null,
//     "preview_text": "View our product catalogs, which provide detailed information in PDF format. Here you will find detailed descriptions of products, their composition, application and benefits for plants.",
//     "preview_link_text": "Learn more",
//     "fs_title": "Information materials",
//     "fs_title_background": null,
//     "fs_view_button": "View catalog",
//     "agricultural_tag": "AGRICULTURAL SOLUTIONS",
//     "agricultural_title": "<p>View <strong>our product catalogs</strong>,<br />which provide detailed information in PDF format</p>",
//     "agricultural_description": "Here you <b>will find detailed descriptions</b> of products, their composition, application and benefits for plants.",
//     "catalogs": [],
//   }
// TODO NOT DONE!!!
const InformationMaterials = () => {
    const dispatch = useDispatch();

    const {
        fs_title,
        fs_title_background,
        fs_view_button,
        agricultural_tag,
        agricultural_title,
        agricultural_description,
    } = useSelector(selectInformationMaterialsPage);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchInformationMaterials());
        // @ts-ignore
    }, [dispatch]);

    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{agricultural_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: agricultural_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                <span dangerouslySetInnerHTML={{ __html: agricultural_description }} />
                            </GradientText>
                        </div>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={informationMaterials} />}>
                    <ProductCatalogBox
                        title="Wuxal catalog 2023"
                        image={wuxalCatalog}
                        text="Check out our Wuxal product catalog for detailed information on composition and usage."
                    />
                    <PDFBox title="Wuxal product flyers" data={filesWuxal} />
                    <ProductCatalogBox
                        title="Fertiplant - UniferX catalog 2023"
                        image={uniferCatalog}
                        text="Check out our Fertiplant - UniferX product catalog for detailed information on composition and usage."
                    />
                    <PDFBox title="UniferX+ product flyers" data={filesUniferX} />
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default InformationMaterials;
